// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"0082b0ea3ded6c12b377","293":"436d1568187492af3ea1","518":"17e1f289ab7a83f61c8c","779":"2490cfb983bb7b9636c2"}[chunkId] + ".js";
};